const StationSchema = {
    id: 1,
    name: 'Station',
    code: 'CODE',
    timezone: 'timezone'
};

export default StationSchema;

export const StationInclude = Object.assign({}, Object.keys(StationSchema));